import React, { useEffect, useContext, useState } from 'react';
import { appContext } from "./../../../AppContext";
import SkillWikiModal from '../wiki/SkillWikiModal';
import SkillsToChose from './SkillsToChose';
import {characterSkillColumns, characterSkillListItems} from '../columns/skillColumns';
import LarpTable from '../../table/LarpTable';
import SlAddSkill from './SlAddSkill';

export default function CharacterSkills({
    allRaces,
    newCharacter,
    setNewCharacter,
    setSomethingChanged,
    isStormvloed
}) {

     const [dataSource, setDataSource] = useState([]);
     const [listSource, setListSource] = useState([]);
     const [isModalVisible, setIsModalVisible] = useState(false);
     const [selectedRecord, setSelectedRecord] = useState({});
     const [isShowAddSkillPointModalVisible, setIsShowAddSkillPointModalVisible] = useState(false);
     const [appState] = useContext(appContext);

      useEffect(() => {
        setDataSource([...newCharacter.skills])
        setListSource(characterSkillListItems(newCharacter.skills, onRowClick, appState, newCharacter, onRemoveClick))
          }, // eslint-disable-next-line
      [newCharacter])

      function onRowClick(record)
      {
        setSelectedRecord(record.skill);
        setIsModalVisible(true);
      }

      const columns = characterSkillColumns(appState, allRaces, dataSource, onRemoveClick, onRowClick, newCharacter)

      function onRemoveClick(removeSkill) {
        setSomethingChanged(true)
        const newSkills = newCharacter.skills.filter(_ => _.skill.id !== removeSkill.skill.id);

        let newHp = newCharacter.hp
        let newStamina = newCharacter.stamina
        let newStrength = newCharacter.strength
        let newMana = newCharacter.mana
        let newRp = newCharacter.rp
        

        if(removeSkill.skill.increaseStats.length > 0) {
          removeSkill.skill.increaseStats.forEach(_ => {
            switch(_.statType.name) {
                case appState.statTypeNames.hp:
                    newHp = newHp - _.amount
                  break;
                case appState.statTypeNames.strength:
                  newStrength = newStrength - _.amount
                break;
                case appState.statTypeNames.mana:
                  newMana = newMana - _.amount
                break;
                case appState.statTypeNames.stamina:
                  newStamina = newStamina - _.amount
                break;
                case appState.statTypeNames.rp:
                  newRp = newRp - _.amount
                break;
                default:
                  break;
            }
          })
        }

        setNewCharacter({
            ...newCharacter,
            skills:newSkills,
            hp:newHp,
            stamina:newStamina,
            strength:newStrength,
            mana:newMana,
            rp:newRp,
        })
    }

    function onAddSkillClick()
    {
      setIsShowAddSkillPointModalVisible(true);
    }

    function addSkillToCharacter(newSkill) {
        setSomethingChanged(true)
        const newSkills = [...newCharacter.skills];
        newSkills.push({
            skill:newSkill
        })

        let newHp = newCharacter.hp
        let newStamina = newCharacter.stamina
        let newStrength = newCharacter.strength
        let newMana = newCharacter.mana
        let newRp = newCharacter.rp

        if(newSkill.increaseStats.length > 0) {
          newSkill.increaseStats.forEach(_ => {
            switch(_.statType.name) {
                case appState.statTypeNames.hp:
                    newHp = newHp + _.amount
                  break;
                case appState.statTypeNames.strength:
                  newStrength = newStrength + _.amount
                break;
                case appState.statTypeNames.mana:
                  newMana = newMana + _.amount
                break;
                case appState.statTypeNames.stamina:
                  newStamina = newStamina + _.amount
                break;
                case appState.statTypeNames.rp:
                  newRp = newRp + _.amount
                break;
                default:
                  break;
            }
          })
        }

        setNewCharacter({
            ...newCharacter,
            skills:newSkills,
            hp:newHp,
            stamina:newStamina,
            strength:newStrength,
            mana:newMana,
            rp:newRp,
        })
    }

    return (
      <>

        <SlAddSkill 
          newCharacter={newCharacter}
          allRaces={allRaces}
          addSkillToCharacter={addSkillToCharacter}
        />
        <LarpTable 
          listSource={listSource}
          columns={columns}
          dataSource={dataSource}
          onDoubleRowClick={onRowClick}
          onAddSkillClick={onAddSkillClick}
        />

        <SkillsToChose 
            setIsModalVisible={setIsShowAddSkillPointModalVisible}
            isModalVisible={isShowAddSkillPointModalVisible}
            allRaces={allRaces}
            newCharacter={newCharacter}
            addSkillToCharacter={addSkillToCharacter}
            isStormvloed={isStormvloed}
        />

        <SkillWikiModal 
          setIsModalVisible={setIsModalVisible}
          isModalVisible={isModalVisible}
          record={selectedRecord}
          allSkills={dataSource}
          allRaces={allRaces}
        />         
      </>
    )
}